// noinspection JSUnusedGlobalSymbols

export class Local {
    public static APP_ID = "local/appId";
    public static APP_VERSION = "local/appVersion";
    public static CORE_VERSION = "local/coreVersion";
    public static PLATFORM_VERSION = "local/platformVersion";
    public static APP_NAME = "local/appName";
    public static DATASERVER_URL = "local/dataserverURL";
    public static TABLE_LOOKUP_URL = "local/tableLookupURL";
    public static LOGIN_TOKEN = "local/loginToken";
    public static DEMO = "local/demo";
    public static IOS_APP_ID = "local/iosAppId";
    public static ANDROID_APP_ID = "local/androidAppId";
}



// WEBPACK FOOTER //
// ./src/app/config-support/config.ts